import PropTypes from 'prop-types';
import React, { useEffect, useCallback } from 'react';
import classnames from 'classnames';
import FocusTrap from './focusTrap/focusTrap';
import PanelGroupContainer from './panelGroup/panelGroupContainer';
import PanelGroupPropTypes from './panelGroup/panelGroupPropTypes';
import { KEYCODE_ESC } from '../../constants';

export default function Sidebar({
  isOpen,
  panelGroups,
  preserveFitToWidth,
  onEscKeyDown,
  isModal,
  updateSidebarWidth,
}) {
  useEffect(() => {
    preserveFitToWidth();
  }, [isOpen, preserveFitToWidth]);

  useEffect(() => {
    updateSidebarWidth();
  }, [updateSidebarWidth]);

  const escKeyListener = useCallback((e) => {
    if (e.keyCode === KEYCODE_ESC) {
      onEscKeyDown(e);
    }
  }, [onEscKeyDown]);

  useEffect(() => {
    if (isOpen) {
      window.addEventListener('keydown', escKeyListener);
    } else {
      window.removeEventListener('keydown', escKeyListener);
    }
  }, [isOpen, escKeyListener]);

  return (
    <FocusTrap isDisabled={!isModal}>
      <div className={classnames('sidebar u-hide-from-print', { 'sidebar-open': isOpen })}>
        {panelGroups.map(panelGroup => (
          <PanelGroupContainer key={panelGroup.id} panelGroup={panelGroup} />
        ))}
      </div>
      <div className="pendo-button-container" />
    </FocusTrap>
  );
}

Sidebar.propTypes = {
  panelGroups: PropTypes.arrayOf(PropTypes.shape(PanelGroupPropTypes)),
  isOpen: PropTypes.bool,
  isModal: PropTypes.bool,
  preserveFitToWidth: PropTypes.func,
  onEscKeyDown: PropTypes.func,
  updateSidebarWidth: PropTypes.func,
};

Sidebar.defaultProps = {
  panelGroups: [],
  isOpen: false,
  isModal: false,
  preserveFitToWidth: () => {},
  onEscKeyDown: () => {},
  updateSidebarWidth: () => {},
};
